import PropTypes from 'prop-types';
import './Detail.css';

// 상세 화면의 구역 카드.
export default function DetailCard({ title, children }) {
    return (
        <section className="admin-detail-card">
            <h2>{title}</h2>
            {children}
        </section>
    );
}

DetailCard.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};
